import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal, theme, Typography } from 'antd';
import { type ReactNode } from 'react';
import { type SiteIdNameDto } from '../../../dto/SiteIdNameDto';
import { type LocalDate } from '../../../utils/local-date';

interface Props {
  isOpen: boolean;
  onOk: () => void;
  onCancel: () => void;
  sites: SiteIdNameDto[];
  orderDate?: LocalDate;
}
const SitesWithExistingOrdersModal = ({
  isOpen,
  onOk,
  onCancel,
  sites,
  orderDate,
}: Props): ReactNode => {
  const { token } = theme.useToken();
  sites = sites ?? [];
  const areMultipleSites = sites.length > 1;
  const sitesNames = sites.map((site) => site.name ?? '').join(', ');

  return (
    <Modal
      open={isOpen}
      okText="Proceed"
      cancelText="Cancel"
      onOk={onOk}
      onCancel={onCancel}
      title={
        <Typography.Title
          style={{
            color: token.colorError,
          }}
        >
          Existing Orders Found <ExclamationCircleOutlined />
        </Typography.Title>
      }
      zIndex={1001}
      okType="danger"
    >
      <div style={{}}>
        <Typography.Text>{areMultipleSites ? 'Sites' : 'Site'}</Typography.Text>
        <Typography.Text strong> {sitesNames} </Typography.Text>
        <Typography.Text>
          {`already ${areMultipleSites ? 'have' : 'has'} an order scheduled for `}
        </Typography.Text>
        <Typography.Text strong> {`${orderDate?.toString() ?? ''}.`}</Typography.Text>
        <Typography.Paragraph>Do you want to proceed?</Typography.Paragraph>
      </div>
    </Modal>
  );
};

export default SitesWithExistingOrdersModal;
